import React from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Button } from '../components/ui/button';
import placeholderImage from '../images/placeholder.jpg';
// import Gallery33 from '../images/compressed-images (3)/Gallery33.jpg';
// import Gallery34 from '../images/compressed-images (3)/Gallery34.jpg';
// import Gallery35 from '../images/compressed-images (3)/Gallery35.jpg';
// import Gallery36 from '../images/compressed-images (3)/Gallery36.jpg';
// import Gallery37 from '../images/compressed-images (3)/Gallery37.jpg';
// import Gallery38 from '../images/compressed-images (3)/Gallery38.jpg';
// import Gallery39 from '../images/compressed-images (3)/Gallery39.jpg';
// import Gallery40 from '../images/compressed-images (3)/Gallery40.jpg';
// import Gallery41 from '../images/compressed-images (3)/Gallery41.jpg';
// import Gallery42 from '../images/compressed-images (3)/Gallery42.jpg';
// import Gallery44 from '../images/compressed-images (3)/Gallery44.jpg';
// import Gallery45 from '../images/compressed-images (3)/Gallery45.jpg';
// import Gallery46 from '../images/compressed-images (3)/Gallery46.jpg';
// import Gallery47 from '../images/compressed-images (3)/Gallery47.jpg';
// import Gallery48 from '../images/compressed-images (3)/Gallery48.jpg';
import Shoulderarthroscopy from '../images/Shoulderarthroscopy.jpg'
import Shoulderarthroscopyprocedure from '../images/Shoulderarthroscopyprocedure.jpg'
import Plastercastingprocedure from '../images/Plastercastingprocedure.jpg'
import Wristarthroscopyprocedure from '../images/Wristarthroscopyprocedure.jpg'
import Shoulderarthroscopyprocedure2 from '../images/Shoulderarthroscopyprocedure-2.jpg'
import Shoulderarthroscopyprocedure3 from '../images/Shoulderarthroscopyprocedure-3.jpg'
import telanganaarthroscopysociety from '../images/Faculty-at-telangana-arthroscopy.jpg'
import hyderabadarthroscopy from '../images/hyderabad-arthroscopy-conclave-2025.jpg'
import telanganaorthopaedic from '../images/telangana-orthopaedic-surgeon-association-conference-2025.jpg'
import Tosacon2025 from '../images/TOSACON-2025.jpg'
import Germany2024 from '../images/germany-2024.jpg'
import Wristarthroscopyprocedure2 from '../images/Wristarthroscopyprocedure-2.jpg'
import WithDrlorenzomerlini from '../images/WithDrlorenzomerlini.jpg'
import WithDrahlamArnout from '../images/WithDrahlamArnout.jpg'
import Tosacon2024 from '../images/FacultyatTASCON2024.jpg'
import carpometarpal from '../images/carpometarpaljointarthroscopy.jpg'
import arthroplastyworkshop from '../images/arthroplastyworkshop.jpg'
import HandMicrosurgery from '../images/Hand&Microsurgery.jpg'
import nephewacademy from '../images/nephewacademy.jpg'
import clinicphoto from '../images/Clinicphoto.jpg'
import Opdconsultation from '../images/Opdconsultation.jpg'
import TotalKneeReplacement from '../images/Totalkneereplacement.jpg'


export default function GalleryPage() {
  // const images = [
  //   {
  //     src: Gallery33,
  //     alt: "Clinic reception and waiting area",
  //     title: "Reception Area",
  //   },
  //   {
  //     src: Gallery34,
  //     alt: "Consultation room",
  //     title: "Consultation Room",
  //   },
  //   {
  //     src: Gallery35,
  //     alt: "Physiotherapy treatment area",
  //     title: "Physiotherapy Area",
  //   },
  //   {
  //     src: Gallery36,
  //     alt: "Examination room with medical equipment",
  //     title: "Examination Room",
  //   },
  //   {
  //     src: Gallery37,
  //     alt: "Rehabilitation gym with exercise equipment",
  //     title: "Rehabilitation Gym",
  //   },
  //   {
  //     src: Gallery38,
  //     alt: "X-ray and imaging room",
  //     title: "Imaging Room",
  //   },
  //   {
  //     src: Gallery39,
  //     alt: "Patient recovery area",
  //     title: "Recovery Area",
  //   },
  //   {
  //     src: Gallery40,
  //     alt: "Orthopedic surgical instruments",
  //     title: "Medical Equipment",
  //   },
  //   {
  //     src: Gallery41,
  //     alt: "Clinic exterior building",
  //     title: "Clinic Exterior",
  //   },
  // ];
  const images = [
    {
      src: TotalKneeReplacement,
      title: "Total Knee Replacement",
    },
    {
      src: Shoulderarthroscopy,
      // alt: "Clinic reception and waiting area",
      title: "Shoulder Arthroscopy Updates at France 2025",
    },
    {
      src: Shoulderarthroscopyprocedure,
      title: "Shoulder Arthroscopy Procedure",
    },
     {
      src: Plastercastingprocedure,
      title: "Plaster Casting Procedure",
    },
    {
      src: Wristarthroscopyprocedure,
      title: "Wrist Arthroscopy Procedure",
    },
    {
      src: Shoulderarthroscopyprocedure2,
      title: "Shoulder Arthroscopy Procedure",
    },
    {
      src: telanganaarthroscopysociety,
      title: "Faculty at Telangana Arthroscopy Society Conference 2025",
    },
    {
      src: hyderabadarthroscopy,
      title: "Faculty at Hyderabad Arthroscopy Conclave 2025",
    },
     {
      src: telanganaorthopaedic,
      title: "Faculty at Telangana Orthopaedic Surgeon Association Conference 2025",
    },
    {
      src: Shoulderarthroscopyprocedure3,
      title: "Shoulder Arthroscopy Procedure",
    },
    {
      src: Tosacon2025,
      title: "Faculty at TOSACON 2025",
    },
    {
      src: Germany2024,
      title: "Visit to Germany to discuss about Regenerative Medicine",
    },
    {
      src: Wristarthroscopyprocedure2,
      title: "Wrist Arthroscopy Procedure",
    },
    {
      src: WithDrlorenzomerlini,
      title: "With Dr.Lorenzo Merlini my mentor,during my fellowship at International Wrist Centre,Paris",
    },
    {
      src: WithDrahlamArnout,
      title: "With Dr.Ahlam Arnout my mentor,during my fellowship at International Wrist Centre,Paris",
    },
    {
      src: Tosacon2024,
      title: "Faculty at TASCON 2024",
    },
    {
      src: carpometarpal,
      title: "1st Carpometarpal Joint Arthroscopy Procedure ",
    },
    {
      src: arthroplastyworkshop,
      title: "1st cmc Joint Arthroplasty Workshop at France 2025",
    },
    {
      src: HandMicrosurgery,
      title: "Hand & Microsurgery",
    },
    {
      src: nephewacademy,
      title: "At Smith n Nephew Academy Singapore",
    },
    {
      src: clinicphoto,
      title: "Clinic Photo",
    },
    {
      src: Opdconsultation,
      title: "OPD Consultation",
    },
    
  ];
  return (
    <div className="min-h-screen flex flex-col">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary to-primary/90 text-primary-foreground py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="max-w-2xl">
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4 font-playfair">
              Clinic Gallery
            </h1>
            <p className="text-lg text-primary-foreground/90 leading-relaxed">
              Take a virtual tour of our modern facilities and treatment areas
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-6 lg:px-8">
          <div className="text-center mb-12">
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Our clinic is equipped with modern facilities and equipment to provide you with the best possible care in
              a comfortable environment.
            </p>
          </div>

          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {images.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow"
              >
                <div className="aspect-[3/3] overflow-hidden">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="text-white font-semibold text-lg">{image.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-muted/30">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-4 font-playfair">Visit Our Clinic</h2>
          <p className="text-lg mb-8 text-muted-foreground max-w-2xl mx-auto">
            Experience our modern facilities and expert care in person. Book an appointment today.
          </p>
          <div className="flex items-center justify-center gap-4 flex-wrap">
            <Button size="lg" asChild>
              <Link to="/book-appointment">Book Appointment</Link>
            </Button>
            <Button variant="outline" size="lg" asChild>
              <Link to="/contact">Get Directions</Link>
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}